import React, { useMemo } from 'react';
import { SelectProps } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import SelectComponent from '@ui/components/Select/Select.component';
import { lang } from '@lang/interfaces/lang';

interface IProps {
    lang: lang;
    deviceTimezone: number;
    onDeviceTimezoneChange: SelectProps['onChange'];
    onInputClick: () => void;
}

const Component: React.FC<IProps> = ({
    lang,
    deviceTimezone,
    onDeviceTimezoneChange,
    onInputClick,
}: IProps) => {
    const timezoneList = useMemo(
        () =>
            new Array(27).fill(0).map((v, i) => {
                const value = i - 12;
                const sign = value < 0 ? '-' : '+';
                const abs = Math.abs(value);
                const hours = `${abs}`.padStart(2, '0');
                const label = `UTC${sign}${hours}:00`;
                return { value, label };
            }),
        [],
    );

    return (
        <FormControl className="device-settings__form" component="form">
            <SelectComponent
                label="timezone"
                name="timezone"
                description="deviceTimezoneTooltip"
                lang={lang}
                value={deviceTimezone}
                values={timezoneList}
                onChange={onDeviceTimezoneChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
        </FormControl>
    );
};

const TimezoneSettingsComponent = React.memo(Component);

export default TimezoneSettingsComponent;
